import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/commonFields';
import { vendorFields } from './common/vendorFields';
import { msg } from '@lingui/core/macro';

export const carbonRemovalMetadata = {
  displayName: msg({
    message: 'Carbon removal',
    context: 'Activity data schema name for carbon removal',
  }),
  fields: {
    ...coreFields,
    ...vendorFields,
    carbon_removal_kind: {
      displayName: msg({
        message: 'Carbon removal activity kind',
        context: 'The category of carbon removal activity.',
      }),
    },
    kgco2e_removed: {
      displayName: msg({
        message: 'kgCO₂e removed',
        context: 'The quantity of greenhouse gases removed.',
      }),
      externalDescription: msg({
        message: 'The quantity of greenhouse gases removed.',
        context: 'kgCO₂e removed',
      }),
    },
  },
} as const satisfies BatMetadataConfigEntry;
